import { render, staticRenderFns } from "./OgHomeArticle.vue?vue&type=template&id=d7a712ce&scoped=true"
import script from "./OgHomeArticle.vue?vue&type=script&lang=js"
export * from "./OgHomeArticle.vue?vue&type=script&lang=js"
import style0 from "./OgHomeArticle.vue?vue&type=style&index=0&id=d7a712ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a712ce",
  null
  
)

export default component.exports